import React from 'react';
import * as S from './styled';

const TitledContent = ({ title, content, component, flex, ...rest }) => (
  <S.TitledContent {...rest} flex={flex}>
    <S.Label>{title}</S.Label>
    {component ? content : <S.Content {...rest}>{content || '-'}</S.Content>}
  </S.TitledContent>
);

export default TitledContent;
